<template>
    <PaginatedMessagesDialog
        :value="value"
        :groups="resolvedGroups"
        :labels-prefix="labelsPrefix"
        :group-labels-prefix="`${labelsPrefix}.types`"
        :close-label="closeButtonLabel"
        @input="$emit('input', $event)"
        @close="$emit('close')"
    />
</template>

<script>
import PaginatedMessagesDialog from '../Dialogs/PaginatedMessagesDialog.vue';
import { groupRoutingWarningsByType } from '@/utils/roteirizacaoWarnings';

export default {
    name: 'AggregatedWarningsDialog',
    components: {
        PaginatedMessagesDialog,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        /** Grupos `{ type, messages[] }` já agrupados por categoria. */
        groups: {
            type: Array,
            default: () => [],
        },
        /** Avisos brutos (`string` ou `{ type, message }`); agrupados quando `groups` está vazio. */
        warnings: {
            type: Array,
            default: () => [],
        },
        labelsPrefix: {
            type: String,
            default: 'routePlanning.dialogs.aggregatedWarnings',
        },
        closeButtonLabel: {
            type: String,
            default: null,
        },
    },
    computed: {
        resolvedGroups() {
            if (Array.isArray(this.groups) && this.groups.length) {
                return this.groups;
            }
            return groupRoutingWarningsByType(this.warnings);
        },
    },
};
</script>
